import { DEFAULT_TIEBREAKERS, PLATFORM_LABELS, STAGE_FORMAT_LABELS, TIEBREAKER_LABELS } from '@pred-hub/shared/constants'
import { accentInk, safeAccent } from '@pred-hub/shared/color'

export function formatPrize(prize) {
  if (!prize?.total) return null
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: prize.currency || 'USD',
      maximumFractionDigits: 0,
    }).format(prize.total)
  } catch {
    return `${prize.total} ${prize.currency ?? ''}`.trim()
  }
}

export function platformLabel(platform) {
  return PLATFORM_LABELS[platform] ?? platform
}

export function platformsLabel(platforms = []) {
  if (platforms.length === 3) return 'Crossplay'
  return platforms.map(platformLabel).join(' + ')
}

export function formatLabel(stages = []) {
  if (!stages.length) return 'Format TBA'
  return stages.map((s) => STAGE_FORMAT_LABELS[s.format] ?? s.format).join(' → ')
}

// "Final", "Semifinal", "Quarterfinal" or "Round 2" for elimination rounds.
export function roundLabel({ round, rounds, bracket }) {
  if (bracket === 'winners' && rounds) {
    const fromEnd = rounds - round
    if (fromEnd === 0) return 'Final'
    if (fromEnd === 1) return 'Semifinal'
    if (fromEnd === 2) return 'Quarterfinal'
  }
  if (bracket === 'grand_final') return 'Grand final'
  if (bracket === 'third_place') return 'Third place'
  if (bracket === 'losers') return `Lower round ${round}`
  return `Round ${round}`
}

// CSS variables that tint a component with an event or team color.
export function accentStyle(color) {
  const accent = safeAccent(color)
  return { '--accent': accent, '--accent-ink': accentInk(accent) }
}

export function plural(n, one, many = `${one}s`) {
  return `${n} ${n === 1 ? one : many}`
}

export function cn(...classes) {
  return classes.filter(Boolean).join(' ')
}

// "Match wins → Game difference → … → Organizer decision" for round-robin and
// Swiss stages; null for elimination stages.
export function tiebreakText(stage) {
  const list = stage.settings?.tiebreakers ?? DEFAULT_TIEBREAKERS[stage.format]
  if (!list) return null
  return [...list, 'manual'].map((key) => TIEBREAKER_LABELS[key]).join(' → ')
}
